import { useContext, useState } from "react";
import CarousselNav from "../../components/Card/CarousselNav";
import WebexIot from "./WebexIoT";
import MerakiIoT from "./MerakiIoT";
import { AuthContext } from "../../context/AuthContext";
import { useEffect } from "react";

export default function IoT() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const { user } = useContext(AuthContext);
    const [valuesType, setValuesType] = useState([]);

    useEffect(() => {
        const nextValues = [];

        if (user.roles.includes("ROLE_WEBEX")) {
            nextValues.push("Webex");
        }

        if (user.roles.includes("ROLE_MERAKI")) {
            nextValues.push("Meraki");
        }

        setValuesType(nextValues);
    }, [user.roles])

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                <div className="ecp-container-content-header">
                    <div className="ecp-container-content-header-title">
                        <div className="page-title page-logo">
                            <h1 className="page-title">IoT</h1>
                        </div>
                        {valuesType.length > 0 && (
                            <CarousselNav arrayValues={valuesType} currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} />
                        )}
                    </div>
                </div>
                {valuesType.length === 1 ?
                    (user.roles.includes("ROLE_WEBEX") ? <WebexIot /> : <MerakiIoT />) :
                    (currentSlide === 0 ? <WebexIot /> : <MerakiIoT />)
                }
            </div>
        </div>
    )
}
